
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gzHgUtpTxpTbiEd40nosi9KXzwjnwtk_45g3W5_ygy_45PxoMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexe8DAHBDwbRweLy6aWX98KSp_453tczU9Holmk6cO5LO3kMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchv3BSNf_V8U3n0ND1F_45NS2CaysmEywt_FrBhPMtQZXCYMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexJnXs62s_b_gcUggVNK2CNZfrUho1IoF4zlLquULGliQMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_931um__E2cFwJzaE3TNpxQIWwdqhQbfJDyDOh2xG_rxZsMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index_454EHNAtePhLSrJvKbdch3B_45fvQ4GIZ3XFoEDTHsCZrwMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93r6dfSpKxqxUqreIyCeAugWw1ZapTV3giadoVaEoagOMMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexom5H4gNJhWtlGcj_D9hErFY6oQWAgIbkpiaMs865oFoMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Df8UWnGZr0U7auUyIsdS0SOilesaVyNMLdxlUfABv9UMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index6MLDzrXEwjjElelTsumXbABYnTuI_M4nHak_45v3tqMccMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexKJ40o2SH6wo2kjmxbavYc_IA1eTP3z6g47EouV5NPawMeta } from "/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index_454EHNAtePhLSrJvKbdch3B_45fvQ4GIZ3XFoEDTHsCZrwMeta || {},
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexom5H4gNJhWtlGcj_D9hErFY6oQWAgIbkpiaMs865oFoMeta || {},
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index6MLDzrXEwjjElelTsumXbABYnTuI_M4nHak_45v3tqMccMeta || {},
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexKJ40o2SH6wo2kjmxbavYc_IA1eTP3z6g47EouV5NPawMeta || {},
    component: () => import("/codebuild/output/src2384365994/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]